import { Extension } from "@tiptap/core";
import { TextSelection } from "@tiptap/pm/state";

/**
 * When Enter splits a paragraph right next to hardBreak(s), the default
 * splitBlock leaves them behind as a trailing <br> at the end of the first
 * paragraph or a leading <br> at the start of the second — invisible
 * structure that renders as weird extra spacing. This extension deletes the
 * hardBreak run touching the split point as part of the same split
 * transaction (one undo step).
 *
 * Only plain top-level paragraphs are handled; list items and other blocks
 * fall through to their own Enter behavior.
 */
export const SplitParagraphTrimsBreaks = Extension.create({
  name: "splitParagraphTrimsBreaks",

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state, view } = editor;
        const { selection } = state;
        if (!(selection instanceof TextSelection)) return false;

        const { $from, $to } = selection;
        if (!$from.sameParent($to)) return false;
        if ($from.depth !== 1 || $from.parent.type.name !== "paragraph") return false;

        // Extend the replaced range over any hardBreak run touching the
        // split point (before the selection start / after the selection end).
        let from = selection.from;
        let to = selection.to;
        while (state.doc.resolve(from).nodeBefore?.type.name === "hardBreak") {
          from -= 1;
        }
        while (state.doc.resolve(to).nodeAfter?.type.name === "hardBreak") {
          to += 1;
        }
        if (from === selection.from && to === selection.to) return false;

        let tr = state.tr;
        if (to > from) {
          tr = tr.delete(from, to);
        }
        tr = tr.split(from).scrollIntoView();
        tr = tr.setSelection(TextSelection.near(tr.doc.resolve(tr.mapping.map(from)), 1));
        view.dispatch(tr);
        return true;
      },
    };
  },
});
